<template>
  <div v-if="show" class="modal">
    <div class="modal-mask"></div>
    <div class="modal-box">
      <div class="modal-box-title">
        {{ config.title }}
      </div>
      <div class="modal-box-subtitle">
        {{ config.subTitle }}
      </div>
      <div class="modal-box-btn" @click="config.btnFunction">
        <div class="modal-box-btn-text">{{ config.btnContent }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Modal',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    config: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {}
  },
  methods: {},
}
</script>
<style lang="less">
@import '../../assets/variable.less';
.modal {
  .flex-center(center);
  .size(100%);
  top: 0;
  left: 0;
  position: fixed;
  z-index: 12;
  background-color: transparent;
  &-mask {
    .size(100%);
    position: fixed;
    top: 0;
    left: 0;
    background: #000000;
    opacity: 0.76;
    z-index: 110;
  }
  &-box {
    z-index: 111;
    .flex-column-center();
    width: 300px;
    height: 195px;
    background: #ffffff;
    border-radius: 12px;
    padding: 30px 18px 18px;
    &-title {
      font-family: PingFangSC-Medium;
      font-size: 22px;
      color: rgba(0, 0, 0, 0.9);
      letter-spacing: 0;
      text-align: center;
      line-height: 22px;
    }
    &-subtitle {
      margin-top: 10px;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.9);
      letter-spacing: 0;
      line-height: 20px;
    }
    &-btn {
      .flex-center(center);
      width: 264px;
      height: 45px;
      margin-top: 30px;
      background: #ffd100;
      border-radius: 9px;
      &-text {
        opacity: 0.7;
        font-family: PingFangSC-Semibold;
        font-size: 14px;
        color: #000000;
        text-align: center;
        line-height: 20px;
      }
    }
  }
}
</style>
